var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "value-object",
    class: {
      'focus-object': _vm.focus
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.objectFocus($event)
      }
    }
  }, [_c('a', {
    staticClass: "inp-type-icon",
    attrs: {
      "href": "#"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.isReference ? '&rarr;' : '&bullet;')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleRef($event)
      }
    }
  }), _vm._v(" "), (_vm.focus || _vm.search) ? _c('span', [(_vm.isReference) ? _c('input-reference', {
    attrs: {
      "placeholder": _vm.placeholder
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isReference && _vm.value['@value']) ? _c('input-subtle', {
    attrs: {
      "placeholder": "Just a value"
    },
    model: {
      value: (_vm.model['@value']),
      callback: function($$v) {
        _vm.$set(_vm.model, '@value', $$v)
      },
      expression: "model['@value']"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isReference && !_vm.value['@value']) ? _c('input-subtle', {
    attrs: {
      "placeholder": "Unnamed"
    },
    model: {
      value: (_vm.model['schema:name']),
      callback: function($$v) {
        _vm.$set(_vm.model, 'schema:name', $$v)
      },
      expression: "model['schema:name']"
    }
  }) : _vm._e()], 1) : _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.placeholder)
    }
  }), _vm._v(" "), _c('input-class', {
    attrs: {
      "placeholder": "wut"
    },
    model: {
      value: (_vm.model['@type']),
      callback: function($$v) {
        _vm.$set(_vm.model, '@type', $$v)
      },
      expression: "model['@type']"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-clear",
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("×")]), _vm._v(" "), (_vm.expanded || !_vm.isReference) ? _c('props-list', {
    attrs: {
      "fragment": _vm.value
    }
  }) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dffa81be","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ValueObject.vue
// module id = 78
// module chunks = 1